import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store';
import { getJobBadges, getUserData } from '@/api';
import { getRememberMe, setImpersonatedBuyerDetails, setRememberMe, setUserDetails } from '@/util';
import { verifyUserInactivity } from '@/util/session';
import Router from './routes';
import { Routes } from '@/constants';

Vue.use(VueRouter)
const { routes } = Router;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})
const guardForMultipleHomes = async (to: any, from: any, next: any) => {
  const { hasUserData, jobs, isLoggedInAsAdmin } = store.getters;
  if (to.matched.some((record: any) => record.meta.session)) {
    if (!isLoggedInAsAdmin) {
      if (!await verifyUserInactivity()) {
        next(false);
      }
    }
  }
  if (to.matched.some((record: any) => record.meta.requireJobId) && hasUserData && (jobs.length > 1)) {
    const selectedHome = getRememberMe()
    if (!selectedHome && !(jobs.some((data: any) => data.jobId === selectedHome))) {
      next('/selecthome');
    }
  } else if (hasUserData && jobs.length < 2) {
    setRememberMe(store.state.user.jobs[0].jobNumber)
    next();
  }
  next();
}

const checkForImpersonationSession = async (to: any, next: any) => {
  const { token, jobId, email } = to.query;
  if (token && jobId && email && store.getters.isLoggedInAsAdmin) {
    setImpersonatedBuyerDetails(jobId.toString(), email.toString());
    await setUserDetails('/');
  }
  next({ name: Routes.DASHBOARD });
}
router.beforeEach(async (to, from, next) => {
  const { signedIn, hasUserData } = store.getters;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (signedIn) {
      if (!hasUserData) {
        await getUserData();
      }
      await guardForMultipleHomes(to, from, next);
    } else {
      next({ name: Routes.SIGNIN, query: { redirect: to.path } })
    }
  } else {
    (to.matched.some(record => record.meta.requiresRedirect) && signedIn)
      ? checkForImpersonationSession(to, next)
      : next();
  }
})

router.beforeResolve(async (to, from, next) => {
  const { signedIn, jobs } = store.getters;
  if (signedIn) {
    const jobId = getRememberMe();
    const job = jobs.filter((data: any) => data.jobNumber === jobId);
    jobId && job.length > 0 && signedIn && getJobBadges(job[0].divisionId, jobId);
  }
  next();
})

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    const title = to.matched.map((record: any) => record.meta.title)[0];
    if (title) {
      document.title = `${title} | Drees Homes`;
    }
  })
})

export default router;
